import { render } from "./CadastroSeguradoModal.vue?vue&type=template&id=8790597e&scoped=true&ts=true"
import script from "./CadastroSeguradoModal.vue?vue&type=script&lang=ts"
export * from "./CadastroSeguradoModal.vue?vue&type=script&lang=ts"

import "./CadastroSeguradoModal.vue?vue&type=style&index=0&id=8790597e&scoped=true&lang=css"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8790597e"]])

export default __exports__